import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authenticated)) {
    // console.log(to.matched.some(record => record.meta.authenticated))
    // alert('check!')

    const key = 'haveLogin'
    if (sessionStorage.getItem(key)) {
      const value = sessionStorage.getItem(key)
      // console.log(value)
      var searchedResult = JSON.parse(value)
      // console.log(searchedResult)
    }

    // console.log('searchedResult', searchedResult)
    if (searchedResult == undefined) {
      next({
        path: '/'
      })
    } else {
      if (
        to.matched.some(record => record.meta.authenticated) ==
        searchedResult.login
      ) {
        // alert('match')
        next()
      } else {
        next({
          path: '/'
        })
      }
    }
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  vuetify: vuetify,
  render: h => h(App)
}).$mount('#app')
